<script lang="ts" setup>
import type {
    CollectionFragment,
    MetadataFragment,
} from '~/lib/graphql/graphql.ts'

const props = defineProps<{
  item: MetadataFragment | CollectionFragment | null
}>()

const media = computed<MetadataFragment | null>(() => {
    if (props.item?.__typename === 'Metadata') {
        return props.item?.relationships.find(r =>
            r.relationship === 'video.featured' || r.relationship === 'audio.featured',
        )?.metadata as MetadataFragment | null
    }
    if (props.item?.__typename === 'Collection') {
        return props.item?.metadataRelationships.find(r =>
            r.relationship === 'video.featured' || r.relationship === 'audio.featured',
        )?.metadata as MetadataFragment | null
    }
    return null
})
</script>

<template>
  <div v-if="media">
    <ContentAudio
      v-if="media.content.type.startsWith('audio/')"
      :metadata="media"
    />
    <ContentVideo
      v-else
      :metadata="media"
    />
  </div>
</template>
